var home = {
	init: function(){
		homeSlide.init();
	}
}
var homeSlide = {
	current: 0,
	max: 0,
	init: function(){
		homeSlide.max = $("#home_recommend ul.recommend_slideshow li").length;
		homeSlide.resize();

		let navHTML = "";
		if(homeSlide.max > 1){
			$("#home_recommend ul.recommend_slideshow li").each(function(i){
				navHTML += '<li><a href="javascript:void(0);">' + i + '</a></li>';
			});
			$(".home_slide_nav ul").html(navHTML);
		}
		setTimeout(function(){
			homeSlide.nav();
			homeSlide.resize();
		}, 500);
	},
	nav: function(){
		$("#home_next").off().on("click", function(){
			homeSlide.inc();
		});
		$("#home_prev").off().on("click", function(){
			homeSlide.dec();
		});
		$("#home_recommend .home_slide_nav ul li a").off().on("click", function(){
			let idx = $("#home_recommend .home_slide_nav ul li a").index(this);
			homeSlide.current = idx;
			homeSlide.change();
		});

		var position,positionX,cx,touching;
		var idx = 0,
		limit = 80;
		var thisSlide;
		$(".recommend_content").off().on({
			'touchstart': function(e) {
				cx 			= 0;
				position 	= getPosition(e);
			},
			'touchmove': function(e) {
				//e.preventDefault();
				var touchX 		= event.touches[0].clientX;
				cx 	= position - getPosition(event);
			},
			'touchend': function(e) {
				if(cx < -limit){
					homeSlide.dec();
				}else if(cx > limit){
					homeSlide.inc();
				}
				cx = 0;
			},
			'touchcancel': function(e){
				cx = 0;
			}
		});
		function getPosition(event){
			return event.touches[0].pageX;
		}
	},
	inc: function(){
		homeSlide.current++;
		if(homeSlide.current >= homeSlide.max){
			homeSlide.current = homeSlide.max-1;
		}else{
			homeSlide.change();
		}
	},
	dec: function(){
		homeSlide.current--;
		if(homeSlide.current < 0){
			homeSlide.current = 0;
		}else{
			homeSlide.change();
		}
	},
	resize: function(){
		let _w = $(".recommend_inner").width();
		let arryH = [];
		$("#home_recommend ul.recommend_slideshow li").each(function(i){
			let _imgH = Math.floor( $(this).find(".img").outerHeight() );
			let _txtH = $(this).find(".ttl_col1").outerHeight();
			let _h = _imgH + _txtH;
			let _left = _w*i;
			$(this).css({
				"width": _w + "px",
				"left": _left + "px"
			});
			arryH.push(_h);
		});
		$("#home_recommend ul.recommend_slideshow").css({
			"height": Math.max.apply(null, arryH) + "px"
		});
		homeSlide.change();
	},
	change: function(){
		let _w = $(".recommend_inner").width();
		$("#home_recommend ul.recommend_slideshow").css({
			"transform": "translate3d(" + homeSlide.current*-_w +  "px, 0,0)"
		});
		$(".home_slide_nav ul li a").removeClass("active");
		$(".home_slide_nav ul li").eq(homeSlide.current).find("a").addClass("active");
		
		if(homeSlide.current === 0){
			$("#home_prev").addClass("disable");
			$("#home_next").removeClass("disable");
		}else if(homeSlide.current === homeSlide.max - 1){
			$("#home_prev").removeClass("disable");
			$("#home_next").addClass("disable");
		}else{
			$("#home_prev").removeClass("disable");
			$("#home_next").removeClass("disable");
		}
		if(homeSlide.max > 1){
			
		}else{
			$("#home_next").addClass("disable");
		}
	}
}